import React from 'react';
import PropTypes from 'prop-types';
import Badge from '../../common2/Badge';

// biome-ignore-start lint/style/useNamingConvention: external
const claimTypeTitles = {
  investigation: 'Investigation',
  partial_damage: 'Partial damage',
  whole_damage: 'Whole damage',
  missing_item: 'Missing item',
  cash_on_delivery: 'Cash on delivery',
};
// biome-ignore-end lint/style/useNamingConvention: external

function ClaimsTypeBadge({ claimType }) {
  return <Badge>{claimTypeTitles[claimType]}</Badge>;
}

ClaimsTypeBadge.propTypes = {
  claimType: PropTypes.string,
};

export default React.memo(ClaimsTypeBadge);
